import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {usersAPI} from '../../../../services/UsersService'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'
import {useAccount} from '../../../../hooks/useAccount'

export function AsideMenuMain() {
  const intl = useIntl()
  const location = useLocation()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const {isAccount, role, accounts} = useAccount()
  const showCdrMenuItem = location.pathname.startsWith('/management/cdr/') && location.pathname !== '/management/cdr/'
  const showCsrMenuItem = location.pathname.startsWith('/management/csr/') && location.pathname !== '/management/csr/'

  const canManageAccountUsers = (isAccount && role === 'OWNER') || (role === 'SUPERVISOR' && accounts.length > 1)

  return (
    <>
      {currentUser?.role !== 'CLIENT' && (
        <>
          <AsideMenuItemWithSub
            to='/management'
            title={intl.formatMessage({id: 'ASIDE.MENU.TITLE.MANAGEMENT'})}
            icon='/media/icons/duotune/general/gen049.svg'
            fontIcon='bi-app-indicator'
          >
            <AsideMenuItem
              to='/management/apps/'
              title={intl.formatMessage({id: 'ASIDE.MENU.MANAGEMENT.ITEM.APPS'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/management/users/'
              title={intl.formatMessage({id: 'ASIDE.MENU.MANAGEMENT.ITEM.USERS'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/management/history/'
              title={intl.formatMessage({id: 'ASIDE.MENU.MANAGEMENT.ITEM.HISTORY'})}
              hasBullet={true}
            />
            {showCdrMenuItem && (
              <AsideMenuItem to='/management/cdr/' title={intl.formatMessage({id: 'APPS.CDR'})} hasBullet={true} />
            )}
            {showCsrMenuItem && (
              <AsideMenuItem to='/management/csr/' title={intl.formatMessage({id: 'APPS.CSR'})} hasBullet={true} />
            )}
          </AsideMenuItemWithSub>
          <div className='menu-item'>
            <div className='menu-content mx-1 my-4'>
              <div className='separator'></div>
            </div>
          </div>
        </>
      )}

      <AsideMenuItem
        to='/apps/'
        title={intl.formatMessage({id: 'ASIDE.MENU.TITLE.INTEGRATIONS'})}
        icon='/media/icons/duotune/abstract/abs022.svg'
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/cdr/'
        title={intl.formatMessage({id: 'APPS.CDR'})}
        icon='/media/icons/duotune/files/fil002.svg'
        fontIcon='bi-app-indicator'
        iconClassName='svg-icon-4'
      />
      <AsideMenuItem
        to='/csr/'
        title={intl.formatMessage({id: 'APPS.CSR'})}
        icon='/media/icons/duotune/graphs/gra001.svg'
        iconClassName='svg-icon-2'
      />
      <div className='menu-item'>
        <div className='menu-content mx-1 my-4'>
          <div className='separator'></div>
        </div>
      </div>
      {canManageAccountUsers && (
        <AsideMenuItem
          to='/account/users/'
          title={intl.formatMessage({id: 'ASIDE.MENU.TITLE.ACCOUNT_USERS'})}
          icon='/media/icons/duotune/general/gen002.svg'
          fontIcon='bi-people'
        />
      )}
      <AsideMenuItem
        to='/settings/profile/'
        title={intl.formatMessage({id: 'ASIDE.MENU.TITLE.PROFILE'})}
        icon='/media/icons/duotune/general/gen019.svg'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
